import React from 'react';

// components
import { YesNo } from '../components/inputs';

function Recording() {
  return (
    <div>
      <YesNo label="Recording Acknowledgement" name="ack_recording" />
    </div>
  );
}

export default Recording;
